// Vendored from prompt-builder-nano `src/state/registry/voice-transcription-models-registry.ts`
// (voice-input-engine P1). Adapted: nano's `RegistryOption` (from its prompt-builder `types/lab`) is
// replaced with a local minimal shape — the portal has no lab types. Model ladder + default are verbatim.

export interface VoiceTranscriptionModel {
  value: string;
  label: string;
  description: string;
}

/**
 * OpenRouter speech-to-text models for mic dictation, in ladder order (first that succeeds wins).
 * STT-purpose-built (not chat-completions).
 *
 * Trimmed 2026-07-05 (Dave) to the two GPT-4o models only — the Whisper Large V3 / V3 Turbo and
 * Google Chirp 3 options were removed for now. A previously-stored slug for a removed model now
 * fails `isKnownVoiceModel` and the settings atom falls back to `DEFAULT_VOICE_TRANSCRIPTION_MODEL`.
 */
export const VOICE_TRANSCRIPTION_MODELS: VoiceTranscriptionModel[] = [
  {
    value: 'openai/gpt-4o-transcribe',
    label: 'OpenAI: GPT-4o Transcribe',
    description: 'Use for noisy or degraded audio — best at reconstructing missing words.'
  },
  {
    value: 'openai/gpt-4o-mini-transcribe',
    label: 'OpenAI: GPT-4o Mini Transcribe',
    description: 'Use for cheap, tidy notes — auto-fixes grammar and formats call summaries.'
  }
];

export const DEFAULT_VOICE_TRANSCRIPTION_MODEL = 'openai/gpt-4o-transcribe';

/** The ladder order the transcription hook tries (default first, then the rest as fallbacks). */
export const VOICE_TRANSCRIPTION_MODEL_LADDER: string[] = VOICE_TRANSCRIPTION_MODELS.map((m) => m.value);

/** True when a stored slug is still a known model (settings validation). */
export function isKnownVoiceModel(slug: string): boolean {
  return VOICE_TRANSCRIPTION_MODELS.some((m) => m.value === slug);
}
